module.exports = __webpack_public_path__ + "img/undraw_live_collaboration_2r4y.4ec11677.svg";